import { getFormat, isValid } from 'gtin';
import { Base_Unit_Type_Enum, Billing_Type_Enum, Product_Family_Name_Enum, Product_Sub_Family, Product_Sub_Family_Name_Enum } from '@kheops/graphql';

export type ProductFamilyMap = {[key in Product_Family_Name_Enum]: Product_Sub_Family_Name_Enum[]};

export const productFamilyMap: ProductFamilyMap = {
  [Product_Family_Name_Enum.Beverages]: [
    Product_Sub_Family_Name_Enum.BeerCider,
    Product_Sub_Family_Name_Enum.NonAlcoholicBeverages,
    Product_Sub_Family_Name_Enum.Spirits,
    Product_Sub_Family_Name_Enum.WineChampagneSparkling,
  ],
  [Product_Family_Name_Enum.FreshFood]: [
    Product_Sub_Family_Name_Enum.Bakery,
    Product_Sub_Family_Name_Enum.Dairy,
    Product_Sub_Family_Name_Enum.Deli,
    Product_Sub_Family_Name_Enum.FishSeafood,
    Product_Sub_Family_Name_Enum.Fruits,
    Product_Sub_Family_Name_Enum.FrozenFood,
    Product_Sub_Family_Name_Enum.RawMeat,
    Product_Sub_Family_Name_Enum.Vegetables,
    Product_Sub_Family_Name_Enum.VegetarianVegan,
  ],
  [Product_Family_Name_Enum.Grocery]: [
    Product_Sub_Family_Name_Enum.SaltyGrocery,
    Product_Sub_Family_Name_Enum.SweetGrocery,
  ],
  [Product_Family_Name_Enum.NonFoodProducts]: [
    Product_Sub_Family_Name_Enum.ClothingTextile,
    Product_Sub_Family_Name_Enum.Floral,
    Product_Sub_Family_Name_Enum.HouseholdCleaning,
    Product_Sub_Family_Name_Enum.GamesToys,
    Product_Sub_Family_Name_Enum.HygieneBeauty,
    Product_Sub_Family_Name_Enum.Pets,
  ],
}

export type ProductSubFamilyMap = { [key in Product_Sub_Family_Name_Enum]: Product_Family_Name_Enum };

export const generateSubFamilyToFamilyMap = (familyMap: ProductFamilyMap): ProductSubFamilyMap => {
  const subFamilyToFamilyMap = {} as ProductSubFamilyMap;

  for (const [family, subFamilies] of Object.entries(familyMap)) {
    subFamilies.forEach((subFamily) => {
      subFamilyToFamilyMap[subFamily] = family as Product_Family_Name_Enum;
    });
  }

  return subFamilyToFamilyMap;
};

export const productSubFamilyMap = generateSubFamilyToFamilyMap(productFamilyMap);

export function GetProductFamilyMapFromSubFamilies(productSubFamilies: Product_Sub_Family[]): ProductFamilyMap {
  return productSubFamilies.reduce((acc, subFamily) => {
    const { name, product_family_name } = subFamily as { name: Product_Sub_Family_Name_Enum, product_family_name: Product_Family_Name_Enum };

    if (acc[product_family_name]) {
      acc[product_family_name].push(name);
    } else {
      acc[product_family_name] = [name];
    }

    return acc;
  }, {} as ProductFamilyMap)
}

export function validateBaseUnitGtin(gtin: string, billingType: Billing_Type_Enum, baseUnitType: Base_Unit_Type_Enum): boolean {
  const gtinIsOfFormat13 = getFormat(gtin) === 'GTIN-13';

  if (billingType === Billing_Type_Enum.WeightDependent && baseUnitType !== Base_Unit_Type_Enum.Bulk) {
    const allowedPrefixes = ['02', '21', '22', '23', '24', '25', '26', '27', '28', '29'];
    const requiredSuffix = '000000';
    const gtinPrefix = gtin.slice(0, 2);
    const gtinSuffix = gtin.slice(-6);

    const hasValidPrefix = allowedPrefixes.includes(gtinPrefix);
    const hasValidSuffix = gtinSuffix === requiredSuffix;

    return gtinIsOfFormat13 && hasValidPrefix && hasValidSuffix;
  }

  try {
    return gtinIsOfFormat13 && isValid(gtin);
  } catch {
    return false;
  }
}
